import type TableView from '../../store/schema/TableView';
import { mutatorAction } from 'satcheljs';

/**
 * Re-points the multi-selection anchor when the row it refers to is about to be removed.
 * Must be called before the row is removed from rowKeys.
 * @param tableView the table view the row is being removed from
 * @param removedRowKey the row key that is about to be removed
 */
export const updateAnchorRowKeyOnRemovalMutator: (
    tableView: TableView,
    removedRowKey: string
) => void = mutatorAction(
    'updateAnchorRowKeyOnRemoval',
    function updateAnchorRowKeyOnRemoval(tableView: TableView, removedRowKey: string): void {
        if (tableView.multiSelectionAnchorRowKey !== removedRowKey) {
            return;
        }

        const removedIndex = tableView.rowKeys.indexOf(removedRowKey);
        // Prefer the row that takes the removed row's place, and fall back to the preceding row.
        tableView.multiSelectionAnchorRowKey =
            tableView.rowKeys[removedIndex + 1] ?? tableView.rowKeys[removedIndex - 1] ?? null;
    }
);
export default updateAnchorRowKeyOnRemovalMutator;
